<template>
  <div class="report">
    <div class="filter">
      位置筛选
      <ul>
        <li :class="{ level: level == 0 }" @click="changeLevel(0)">1-6</li>
        <li :class="{ level: level == 1 }" @click="changeLevel(1)">7-12</li>
        <li :class="{ level: level == 2 }" @click="changeLevel(2)">13-18</li>
        <li :class="{ level: level == 3 }" @click="changeLevel(3)">19-24</li>
        <li :class="{ level: level == 4 }" @click="changeLevel(4)">25-30</li>
        <li :class="{ level: level == 5 }" @click="changeLevel(5)">31-36</li>
        <li :class="{ level: level == 6 }" @click="changeLevel(6)">37-42</li>
        <li :class="{ level: level == 7 }" @click="changeLevel(7)">43-48</li>
        <li @click="exportPDF">导出</li>
        <li @click="paixudialogVisible = true">排序</li>
      </ul>
    </div>

    <div class="table">
      <el-row type="flex" align="middle" v-if="reportTable">
        <el-col :span="24">
          <table border v-for="(item, i) in reportTable" :key="i">
            <tbody>
              <tr rowspan="8" class="th">
                <td rowspan="8" style="width: 130px; background: white">
                  <div class="px">
                    平行志愿{{ i + 1 + level * 6 }}
                  </div>
                  <div v-if="item.name == '暂无'">
                  </div>
                  <div v-else>
                    <div class="fc" v-if="item.tiaoji">服从调剂</div>
                    <div class="fc" v-else style="color: red">拒绝调剂</div>
                  </div>

                  <div class="del" v-if="item">
                    <el-button round size="mini" type="success" plain v-if="item.name && item.name != '暂无'"
                      @click="editCollege(item, i + level * 6)">编辑</el-button>
                  </div>

                  <div class="del" v-if="item">
                    <el-button round size="mini" type="danger" plain @click="delCollege(item, i)">删除</el-button>
                  </div>
                  <div class="huanwei" v-if="item">
                    <el-popover popper-class="popover-f" placement="bottom" trigger="hover">
                      <div class="popover-box">
                        <p class="box-title">志愿位置</p>
                        <span v-for="h in len" :key="h" class="box-item" @click="changeCollege(h - 1, i + level * 6)">
                          <span v-if="record.select_code[h - 1] != ''" class="box-item-box"
                            style="background: #fbbfbb; border: #fbbfbb;">{{ h }}</span>
                          <span v-else class="box-item-box">{{ h }}</span>
                        </span>
                      </div>
                      <el-button style="margin-left: 15px;" round size="mini" slot="reference" type="primary"
                        plain>换位</el-button>
                    </el-popover>
                  </div>
                </td>
                <td colspan="7">
                  <span class="name">{{ item.name }}</span>
                  <span>{{ item.group_name }}</span>
                  <span>所在地：{{ item.city_name }} </span>
                  <span>招生代号：{{ item.school_id }} </span>
                  <span>院校计划：{{ item.plan_num }} </span>
                  <span>录取规则：{{ item.lqgz }}</span>
                  <span>选科要求：{{ item.demand }}</span>
                </td>
              </tr>
              <tr>
                <td class="th" style="width: 100px">专业序号</td>
                <td class="th">专业代号/名称</td>
                <td class="th" style="width: 300px">专业详情</td>
                <td class="th" style="width: 100px">专业计划</td>
                <td class="th" style="width: 100px">学费标准</td>
                <td class="th" style="width: 30px; text-align: center;">移动</td>
              </tr>
              <tr v-for="(val, key) in record.specialty[i + level * 6]" :key="key" draggable="true"
                @dragstart="dragStarts(key)" @dragover.prevent="dragOver" @drop="drops(key, i + level * 6)">
                <td class="td-height">{{ val.specialty_id }} </td>
                <td class="td-height">{{ val.specialty_name }} </td>
                <td class="td-height">{{ val.remarks }}</td>
                <td class="td-height">{{ val.plan_num }}</td>
                <td class="td-height">{{ val.tuition }}</td>
                <td class="td-height" style="text-align: center;"><img src="@/assets/img/move.png" alt=""
                    style="width: 20px; vertical-align: middle; "></td>
              </tr>

              <tr v-for="test in 6 - record.specialty[i + level * 6].length" :key="test + i + 'dfd'">
                <td style="height: 45px"></td>
                <td style="height: 45px"></td>
                <td style="height: 45px"></td>
                <td style="height: 45px"></td>
                <td style="height: 45px"></td>
                <td style="height: 45px"></td>
              </tr>
            </tbody>
          </table>
        </el-col>
      </el-row>
      <el-row type="flex" align="middle" v-if="!reportTable">
        <el-col :span="24">
          <div style="margin-top: 20px; text-align: center;"> 暂无志愿表</div>
        </el-col>
      </el-row>
    </div>

    <el-dialog :visible.sync="dialogVisible" class="mojarDialog" width="1400px" :show-close="false"
      :append-to-body="true" :close-on-click-modal="false" destroy-on-close>
      <div style="position: absolute;
    right: 10px;
    z-index: 999;
    top: -4px;
    font-size: 40px;
    font-weight: 100;" @click="colse()">×</div>
      <mojar-page :collegeDatas="collegeData" :subject_id="subject_id" :oldLine="oldLine" :userInfo="userInfo"
        :rankingData="rankingData" :record="record" v-if="dialogVisible" />
    </el-dialog>

    <el-dialog :visible.sync="paixudialogVisible" class="mojarDialog" width="1400px" :show-close="false"
      :append-to-body="true" :close-on-click-modal="false" destroy-on-close>
      <div style="position: absolute;
    right: 10px;
    z-index: 999;
    top: -4px;
    font-size: 40px;
    font-weight: 100;" @click="colse()">×</div>
      <div style="padding: 40px 60px 0;">
        <div class="paixu">
          <div style="width: 120px;">志愿位置</div>
          <div style="width: 180px;">院校名称</div>
          <div style="width: 120px;">招生代号</div>
          <div style="width: 180px;">专业组</div>
          <div style="width: 120px;">计划数</div>
          <div style="width: 120px;">上年最低分</div>
          <div style="width: 120px;">上年最低分位次</div>
          <div style="width: 120px;">移动</div>
        </div>
      </div>
      <div style="height: 610px; overflow-y: scroll; padding: 0 60px 0;">
        <div v-for="(item, i) in record.table" :key="i" class="paixu" draggable="true" @dragstart="dragStart(i)"
          @dragover.prevent="dragOver" @drop="drop(i)">
          <div style="width: 120px;">{{ i + 1 }}</div>
          <div style="width: 180px;">{{ item.name }}</div>
          <div style="width: 120px;">{{ item.school_id }}</div>
          <div style="width: 180px;">{{ item.group_name }}</div>
          <div style="width: 120px;">{{ item.plan_num }}</div>
          <div style="width: 120px;">{{ item.min_score_1 }}</div>
          <div style="width: 120px;">{{ item.ranking_1 }}</div>
          <div style="width: 120px;">
            <img src="@/assets/img/move.png" alt="" style="width: 20px; vertical-align: bottom;">

          </div>
        </div>
      </div>


    </el-dialog>
  </div>
</template>

<script>
import drag from "../../utils/drag";
import { mapMutations, mapState } from "vuex";
import mojarPage from "./components/mojar_page/index.vue";
export default {
  props: ['new_batch', 'subject_id', 'rankingData'],
  name: '',
  directives: { drag },
  data() {
    return {
      nav: 2,
      level: 0,
      record: {

      },
      oldLine: {},
      reportTable: {},
      len: 48,
      dialogVisible: false,
      paixudialogVisible: false,
      collegeData: null,

      list: [
        { id: 1, name: 'Item 1' },
        { id: 2, name: 'Item 2' },
        { id: 3, name: 'Item 3' },
      ],
      draggedIndex: null,
    };
  },
  computed: { ...mapState(["userInfo"]) },
  components: {
    mojarPage,
  },
  watch: {
    new_batch() {
      this.getOldCityScore()
      this.getReport()
    }
  },
  created() {
    this.$emit("Nav", 3);
    this.getOldCityScore()
    this.getReport()
  },
  methods: {
    ...mapMutations(['setRecord']),
    dragStart(index) {
      this.draggedIndex = index;
    },
    dragOver() { }, // 阻止默认行为，允许放置元素。
    drop(index) {
      this.record.table = this.moveElementInArray(this.record.table, this.draggedIndex, index)
      this.record.select_code = this.moveElementInArray(this.record.select_code, this.draggedIndex, index)
      this.record.specialty = this.moveElementInArray(this.record.specialty, this.draggedIndex, index)
      this.updateReport(this.record)
      this.changeLevel(this.level)
      this.draggedIndex = null; // 重置拖动索引。
    },
    dragStarts(index) {

      this.draggedIndex = index;
    },
    drops(index, key) {
      const element = this.record.specialty[key].splice(this.draggedIndex, 1)[0];
      this.record.specialty[key].splice(index, 0, element);
      this.updateReport(this.record)
      this.changeLevel(this.level)
      this.draggedIndex = null; // 重置拖动索引。
    },


    // 根据批次往年录取分数线
    getOldCityScore() {
      this.$fecth
        .post("common/getOldLine", {
          subject: this.userInfo.subject,
          new_batch: this.new_batch,
        })
        .then((res) => {
          this.oldLine = res
        });
    },

    getReport() {
      let data = {
        user_id: this.userInfo.id,
        subject: this.userInfo.subject,
        new_batch: this.new_batch,
      }
      this.$fecth.post("volunteer/getUserReport", data).then((res) => {

        if (res.record) {
          this.record = JSON.parse(res.record)
          console.log(this.record)
          this.reportTable = this.record.table.slice(0, 6)

        } else {
          this.record = []
          this.reportTable = []
        }
      })
    },

    editCollege(item, i) {
      this.collegeData = item
      console.log(item, i)
      this.dialogVisible = true
    },

    delCollege(item) {
      if (item.select_code) {
        let select_code_id = this.record.select_code.indexOf(item.select_code)
        //如果这个学校填过就删除
        if (select_code_id > -1) {
          this.record.table[select_code_id] = {
            name: "暂无",
          }
          this.record.select_code[select_code_id] = ''
          this.record.specialty[select_code_id] = []
        }
        this.updateReport(this.record)
        this.changeLevel(this.level)
      }
    },

    changeCollege(h, i) {
      this.record.table = this.moveElementInArray(this.record.table, i, h)
      this.record.select_code = this.moveElementInArray(this.record.select_code, i, h)
      this.record.specialty = this.moveElementInArray(this.record.specialty, i, h)
      this.updateReport(this.record)
      this.changeLevel(this.level)
    },

    moveElementInArray(array, fromIndex, toIndex) {
      const element = array.splice(fromIndex, 1)[0];
      array.splice(toIndex, 0, element);
      return array
    },

    updateReport(record) {
      this.$fecth
        .post("volunteer/updateReport", {
          user_id: this.userInfo.id,
          subject: this.userInfo.subject,
          new_batch: this.new_batch,
          record: JSON.stringify(record)
        })
      this.$store.commit('setRecord', record)
      this.$emit('getNum')
    },
    changeLevel(e) {
      this.level = e
      let num = e * 6
      this.reportTable = this.record.table.slice(num, num + 6)
    },
    showTips(flag, msg) {
      const title = flag == 1 ? "成功" : "失败";
      const type = flag == 1 ? "success" : "error";
      this.$notify({
        title: title,
        message: msg,
        type: type,
        duration: 2000,
      });
    },

    colse() {
      this.dialogVisible = false
      this.paixudialogVisible = false
      this.getReport()
    },
    exportPDF() {
      this.$router.push(
        "/download?new_batch=" +
        this.new_batch
      );
    }
  },
};
</script>

<style scoped lang='less'>
.report {
  width: 1200px;
  margin: 0 auto;
  background: white;
}

.filter {
  padding: 0 12px;
  margin-top: 15px;

  ul {
    display: inline-block;
    list-style: none;
    position: relative;
    top: 7px;
  }

  li {
    float: left;
    width: 60px;
    text-align: center;
    margin-left: 20px;
    border: 1px solid #707070;
    border-radius: 19px;
    padding: 2px 7px;
  }

  li:hover {
    background: #459df6;
    color: white;
    border: #459df6;
    border: 1px solid #459df6;
  }

  .level {
    background: #459df6;
    color: white;
    border: #459df6;
    border: 1px solid #459df6;
  }
}

.top {
  margin-top: 20px;
  border-bottom: 4px solid #459EFF;
  height: 40px;
}

.right {
  float: right;
  height: 36px;

  ul {
    display: inline-block;
    list-style: none;
  }

  li {
    float: left;
    margin-left: 10px;
    height: 36px;
    padding: 17px;
    line-height: 3px;
    border-radius: 5px 5px 0 0;
  }

  li:hover {
    color: white;
    background: #459EFF;
    border-bottom: 1px solid #459EFF;
  }

}

.nav {
  color: white;
  background: #459EFF;
  border-bottom: 1px solid #459EFF;
}





.table {
  margin: 0 auto;

  table {
    font-size: 14px;
    width: 100%;
    border-collapse: collapse;
    margin-top: 30px;
    border: 1px solid #dddddd;
    margin-bottom: 10px;

    .th {
      font-size: 16px;
      background: #f4f7fc;
      line-height: 35px;

      .name {
        font-size: 18px;
        font-weight: bold;
      }

      span {
        margin-right: 15px;
      }

      .col {
        margin-left: 0;
        color: #459df6;
      }
    }

    .th,
    td {
      line-height: 35px;
      padding: 5px 13px;
    }
  }

  .del {
    text-align: center;
    margin-bottom: 10px;
  }

  .huanwei {
    text-align: center;
    margin-bottom: 10px;
  }
}

.px {
  margin-top: 20px;
  text-align: center;
  font-size: 14;
  margin-bottom: 10px;
}

.fc {
  text-align: center;
  color: #459df6;
  margin-bottom: 10px;
}
</style>


<style lang="less">
.mojarDialog {
  .el-dialog__header {
    padding: 0;
  }

  .el-dialog__body {
    padding: 0;
  }
}

.popover-f {
  width: 350px;
  color: black;
  min-width: 0;

  .box-title {
    color: #459df5;
    padding-bottom: 10px;
    border-bottom: 1px solid white;
  }

  .box-item {
    display: inline-block;
  }

  .box-item-box {
    display: inline-block;
    font-size: 14px;
    color: #707070;
    border-radius: 3px;
    background: #daedfc;
    margin: 3px 3px;
    width: 30px;
    line-height: 30px;
    height: 30px;
    text-align: center;
    border: 1px solid #daedfc;
  }

  .box-item-box:hover {
    display: inline-block;
    color: #459df5;
    background: white;
    border: 1px solid #459df5;
  }
}

.paixu {
  background: #f4f7fc;
  padding: 30px 40px;
  width: 1200px;
  margin-bottom: 20px;

  div {
    display: inline-block;
    text-align: center;
  }
}
</style>